import { ACCESS_GROUPS } from '../config';
import moment from 'moment';
import { SuperAdmin, permissionAuthorities } from './AllTables';

class Utils{

  getStoredValue(key) {
    try {
      const item = window.sessionStorage.getItem(key);
      return JSON.parse(item);
    } catch (error) {
      console.log(error);
    }
  }

  getLoginInUserName = () =>{
    return this.getStoredValue('resp')?.response.name.charAt(0).toUpperCase() + this.getStoredValue('resp')?.response.name.slice(1)
  }

  setStoredValue(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log(error);
    }
  }

  authToken() {
    let userInfo = this.getStoredValue('resp');
    if (userInfo && `response` in userInfo) {
      return userInfo.response['token'];
    }
    return null;
  }

  getUserRights() {
    let GROUPS = ACCESS_GROUPS || {};
    let userInfo = this.getStoredValue('resp');
    if (!userInfo || !userInfo.response) return [];
    const memberOf = userInfo.response.memberOf;
    let hasRights = Object.keys(GROUPS).filter(group => {
      return GROUPS[group].some(grp => memberOf.includes(grp));
    });
    return hasRights;
  }


  soiDomainBased() {
    let result = 0;
    let userInfo = this.getStoredValue('resp');
    if (userInfo && `response` in userInfo) {
      let theme = userInfo.response['userProfile']['theme'];
      result = this.isJsonString(theme)['ISSOIDomainBased'];
    }
    return result;
  }
  
  getUserId() {
    let userInfo = this.getStoredValue('resp');
    if (userInfo && `response` in userInfo) {
      return userInfo.response['userProfile']['userId'];
    }
  }

  isJsonString(str) {
    if (typeof str !== "string") {
      return str;
    }
    try {
      return JSON.parse(str);
    }
    catch (error) {
      return [];
    }
  }

  shortInt(value) {
    let isNegative = value < 0;
    let n = Math.abs(value).toFixed(2);
    let lastValue = "";
    if (n < 1e3) lastValue += n.toString();
    if (n >= 1e3 && n < 1e6) lastValue += +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) lastValue += +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) lastValue += +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) lastValue += +(n / 1e12).toFixed(1) + "T";

    return isNegative?`-${lastValue}`:lastValue;
  }
    
  trunc(str, count) {
    let dots = String(str).length > count ? "..." : "";
    return String(str).substring(0, count) + dots;
  }
  
  getNodeStatus(status) {
    const nodeStatusColors = {
      "significant_growth": "#3f6c51",
      "modest_growth": "#95c1a6",
      "no_change": "#bfcad8",
      "modest_loss": "#da7f7f",
      "significant_loss": "#b60000",
      "l": "#3f6c51",
      "m": "#e3c567",
      "h": "#b60000",
      "default": "#CCCCCC"
    };

    return nodeStatusColors[status] || nodeStatusColors.default;
  }

  getOption = (data) => {
    let chartStr = data
      ? JSON.parse(data)
      : {
        xAxis: { data: [] },
        series: [{ data: [], markLine: { data: [{ xAxis: "" }] } }],
      };
    return {
      xAxis: {
        show: false,
        type: "category",
        data: chartStr.xAxis?.data,
      },
      yAxis: { show: false },
      tooltip: { show: true },
      grid: { show: false, left: 0, right: 0, top: "15%", bottom: "10%"},
      series: chartStr.series.map((item, _i) => ({
        data: item.data,
        name: item.name,
        type: "line",
        smooth: true,
        showSymbol: false,
        itemStyle: {
          normal: {
            // color: "#365C84",
            lineStyle: {
              width: 1.5,
              color: this.getStoredValue('isDarkMode') ? "#fff" : "#365C84",
            },
          },
        },
      })),
    };
  };
  
fixPrecision(data,value=2){
  return data.map(item => item.toFixed(value));
}

  showDate = (dateString)=> {
    const currentDate = new Date();
    const inputDate = new Date(this.convertShortDate(dateString));
  
    // Set the time part of both dates to midnight to compare only the date portion.
    currentDate.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
  
    const oneDayInMillis = 24 * 60 * 60 * 1000; // Milliseconds in a day
  
    if (currentDate - inputDate === 0) {
      return "Today";
    } else if (currentDate - inputDate === oneDayInMillis) {
      return "Yesterday";
    } else {
      return this.convertShortDate(dateString);
    }
  }
  convertShortDate = (date = new Date()) =>
    moment.utc(date).format('MM/DD/YYYY').toString();
  convertLongDate = (date = new Date()) =>
    moment.utc(date).format('MM/DD/YYYY hh:mm A').toString();
  //convertShortDate = (date = new Date()) =>
    //moment.utc(date).format(this.getStoredValue(global)?.DATE_FORMAT_SHORT ?? 'YYYY/DD/MM').toString();
  //convertLongDate = (date = new Date()) =>
    //moment.utc(date).format(this.getStoredValue(global)?.DATE_FORMAT_LONG ?? 'MM/DD/YYYY hh:mm A').toString();

seriesObject(item,dottedLineIndex,mini){
  return {
    type: 'line',
    showSymbol: item.name === 'KPI' ? true : false,
    symbol: 'circle',
    symbolSize: 5,
    smooth: true,
    name: item.name,
    data: item.name !== 'KPI' ? this.fixPrecision(item.data) : dottedLineIndex ? this.fixPrecision(item.data).map((value, index) => (index > dottedLineIndex ? '' : value)):this.fixPrecision(item.data),
    lineStyle:
      item.name !== 'KPI'
        ? {
            color: item.name === 'High Acceptance Range' ? '#CC0000' : '#238823',
            type: 'dashed',
            width: 1,
        }
        : null,
    markPoint: item.markPoint
      ? {
          symbolSize: mini === true ? 10 : 30,
          data: item.markPoint.map((point) => {
            return {
              xAxis: point.xAxis,
              yAxis: point.yAxis,
              symbol: 'circle',
              symbolSize: mini === true ? 8 : 10,
              itemStyle: {
                color: '#CC0000',
              },
            };
          }),
      }
      : null,
    }
};

getOptionPMF(forecastingDate, xAxis, series, title, mini,isDashBoard, isDarkMode, chartType) {
  let dottedLineIndex = null; 
  xAxis.map((value,index) => {if(value == forecastingDate){dottedLineIndex=index}});
  
  let seriesObj = series.map((item) => (this.seriesObject(item,dottedLineIndex,mini)));

  // forecasting logic
  const kpiItem = series.filter((item) => item.name === 'KPI')[0];

  const kpiOpject = this.seriesObject(kpiItem,dottedLineIndex,mini);

  
  if(kpiItem && dottedLineIndex){
    const dashedSeries = {...kpiOpject, 
      name: "Primary Metric Forecasting",
      data: this.fixPrecision(kpiItem.data).map((value, index) => (index < dottedLineIndex ? '' : value)), 				
      lineStyle:{
        color: '#065196',
        type: 'dashed',
        width: 1.5
      },
    };

    const currentDateLine = {...kpiOpject, 
      name:"Forecasting Date",
      data: xAxis.map((value) => (forecastingDate)),
      type: 'line',
      markLine: {
        symbol: 'none',
        label: {
        show: false
        },
        data: [
        {
          xAxis: `${forecastingDate}` // Set the y-coordinate of the line (0 in this case)
        }
        ],
        lineStyle:{
          type: 'solid',
          width: 2
        }
      }
    };
    seriesObj = [...seriesObj,currentDateLine,dashedSeries];
  }

  const option = {
    title: {
      text: title,
      //subtext: "subtitle",
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: isDarkMode ? "#121212" : "#fafafa",
    },
    legend: {
    
      top: mini ?2:25,

      padding: [5, 5, 0, 0],
      textStyle: {
        fontSize: mini ? 8 : 12,
      },
    },
    toolbox: {
      show: mini === true ? false : true,
      feature: {
        // dataZoom: {
        //   yAxisIndex: "none",
        // },
        //dataView: { readOnly: false },
        magicType: {
          type: ['line', 'bar'],
          title: { line: 'Line', bar: 'Bar' },
        },
        //restore: {title: "Restore"},
        saveAsImage: { title: 'Save Image' },
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxis,
    },
    yAxis: {
      type: 'value',
      axisLabel: !isDashBoard ? {
        formatter: (value) => this.yaxisFormatter(value,chartType),
      }:{},
      boundaryGap: [0, '100%'],
      min: function (value) {
        return Math.floor(value.min - value.min * 0.02);
      },
      max: function (value) {
        return Math.ceil(value.max + value.max * 0.1);
      },
      scale: true,
      axisLine: { onZero: false },
    },
    series: seriesObj,
    dataZoom:
      mini === true
        ? [
            {
              id: 'dataZoomX',
              type: 'slider',
              xAxisIndex: [0],
              filterMode: 'filter',
              handleSize: '70%',
              textStyle: {
                fontSize: 6,
              },
              handleIcon:
                'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z', //
            },
            {
              id: "dataZoomY",
              type: "slider",
              yAxisIndex: [0],
              show:false,
              start:0,
              end: isDashBoard ? 95: 100,
              filterMode: "filter",
              handleSize: "70%",
              textStyle: {
                fontSize: 6
              },
              handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z"
            }
          ]
        : [
            
            {
              id: 'dataZoomX',
              type: 'slider',
              xAxisIndex: [0],
              filterMode: 'filter',
              handleSize: '80%',
              textStyle: {
                fontSize: 8,
              },
              handleIcon:
                'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z', //
            },
            {
              id: "dataZoomY",
              type: "slider",
              yAxisIndex: [0],
              show:false,
              start:0,
              end: isDashBoard ? 95: 100,
              filterMode: "filter",
              handleSize: "70%",
              textStyle: {
                fontSize: 6
              },
              handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z"
            }
            
          ],
    color: ['#065196', '#238823', '#CC0000', '#1890ff', '#065196'],
  };

  return option;
}

yaxisFormatter(value, chartType) {
  if (chartType === '$') {
    let newVal = this.shortInt(value);
    return `${newVal} ${chartType}`;
  }
  return `${value.toLocaleString()} ${chartType}`;
}

  getPermission(feature){
    let userInfo = this.getStoredValue('resp');
    if (!userInfo || !userInfo.response) return [];
    const response = userInfo.response;
    const memberOf = userInfo.response.memberOf;
    if(memberOf.includes(SuperAdmin)){
      const {Read,Write,Delete} = permissionAuthorities;
      return [Read,Write,Delete]
    }
    else if (response && `permissions` in response) {
      if(!(response.permissions) || !response.permissions[feature]) return []; 
      const featureData = response.permissions[feature];
      return featureData?featureData?.authorities:[];
    }
    return [];
  }

}

export default new Utils();
